import { Item } from '@ntap/core';

export class Datoteka {
  constructor() {
    //
  }

  'en~datoteka~id' = 0;
  'en~datoteka~rezidualni_podaci' = false;
}

type IDatoteka = Datoteka;

export function isDatoteka(item: Item): item is IDatoteka {
  return Object.keys(new Datoteka()).every(
    (key) => Object.keys(item).indexOf(key) > 0
  );
}
